export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "containers_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "package_groups_from_stock_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pallets en Stock"])},
          "total_containers": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("count")), " contenedores"])},
          "total_package_groups_from_stock": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("count")), " pallets"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])}
        }
      }
    }
  })
}